<template>
  <div>
    <v-card class="card--flex-toolbar" flat>
        <v-tabs color="grey lighten-3" v-model="current_tab" dark slider-color="grey darken-4">
            <v-tab ripple v-for="tab in tabs" :key="tab.href" :href="tab.href" class="grey--text text--darken-4 caption">{{tab.text}}</v-tab>
        </v-tabs>
    </v-card>
    <v-card v-if="isLoading" height="50vh">
      <v-content class="content-background">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    </v-card >
     <v-tabs-items v-else v-model="current_tab">
          <v-tab-item transition="fade" :reverse-transition="false" value="overview">
            <FilmOverview v-if="film" :film.sync="film" :uploaded_media_count="uploaded_media_count" @navigateToUpload="navigateToUpload()"></FilmOverview>
          </v-tab-item>
           <v-tab-item transition="fade" :reverse-transition="false" value="basic-details">
            <FilmBasicDetails v-if="film" :film.sync="film" @onSave="saveFilm" ></FilmBasicDetails>
          </v-tab-item>
          <v-tab-item transition="fade" :reverse-transition="false" value="files">
            <FilmFiles ref="filmFilesUpdate" v-if="film" :film.sync="film" @onSave="saveFilm"></FilmFiles>
          </v-tab-item>
          <v-tab-item transition="fade" :reverse-transition="false" value="right-holder">
            <FilmRightHolder v-if="film" :film.sync="film" @onSave="saveFilm"></FilmRightHolder>
          </v-tab-item>
      </v-tabs-items>
  </div>
</template>
<script>
import i18n from "@/i18n";
import FilmOverview from "./FilmOverview.vue";
import FilmBasicDetails from "./FilmBasicDetails.vue"
import FilmFiles from "./FilmFiles.vue";
import FilmRightHolder from "./FilmRightHolder.vue";
export default {
  name: "FilmUpdateRoot",
  components: {
    FilmOverview,
    FilmBasicDetails,
    FilmFiles,
    FilmRightHolder
  },
  data() {
    return {
      active: null,
      current_tab: 'overview',
      film: null,
      isLoading: false,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      tabs: [
          {
            text: i18n.t('film.update.tabs.overview.title'),
            href: '#overview'
          },
          {
            text: i18n.t('film.update.tabs.basic_details.title'),
            href: '#basic-details'
          },
          {
            text: i18n.t('film.update.tabs.files.title'),
            href: '#files'
          },
          {
            text: i18n.t('film.update.tabs.right_holder.title'),
            href: '#right-holder'
          },

      ]
    };
  },
  created() {
    this.bootstrap();
  },
  methods: {
    /**
     * Fetch all dependency of a film in paraent
     */
    async bootstrap() {
      this.isLoading = true;
      await Promise.all([
        await this.$store.dispatch("film/setEditableFilm", {
            id: this.$route.params.film_id
        }),
        this.$store.dispatch("files/get", {
          model_type: "film",
          model_id: this.$route.params.film_id
        })
      ])
      .then((responses) => {
        // console.log('film data ----->',responses)
        this.film = responses[0];
        this.uploaded_media_count = responses[1].files.length
      }).catch((error) => {
         this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    async saveFilm(film) {
      try {
        /*update film.keywords(ids) with assigned keywords(string) */
        // this.keywords = this.assigned_keywords;
        var response = await this.$store.dispatch(
          "film/update",
          this.film
        );
        this.film = response.film

        this.$store.dispatch("app/showMessage", {
          message: "Updated Successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    /**
     * Navigate to upload and open uploader dialog
     */
    navigateToUpload() {
      this.current_tab = 'files';
      this.$refs.filmFilesUpdate.openUploadBox();
    }

  },
};
</script>
<style scoped>
>>> .v-window__container{
  height: auto !important;
}
</style>
